import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsd from '../components/shared/InnerTabsd';
import { EditIcon, PlusIcon, CalendarIcon2, LockIcon } from '../components/shared/Icons';
import DepartureTicketForm from './DepartureTicketForm';
import NewDeparture from './NewDeparture';
import DepartureUpload from './DepartureUpload';
import FilterClientTickets from './FilterClientTickets';
import CalendarIframe from './CalendarIframe';
import ChangePassword from './ChangePassword';
import FilterDeparture from './FilterDeparture';










const TABS = [
  {
    id: 'workflowiglu',
    label: 'Add',
    
  },
  {
    id: 'updateiglu',
    label: 'Updates',
    
  },
  {
    id: 'calendariglu',
    label: 'Calendar',
    
  },
  {
    id: 'personaliglu',
    label: 'Account',
    
  },
  
];

const WORKFLOW_INNER = [
  { id: 'newform', label: 'New Departure', icon: <PlusIcon />, component: NewDeparture },
  { id: 'departureupload', label: 'Departure Upload', icon: <PlusIcon />, component: DepartureUpload },
  { id: 'clientticket', label: 'New Ticket', icon: <PlusIcon />, component: DepartureTicketForm },
  
];


const UPDATE_INNER = [
  { id: 'updatedepartesm', label: 'Update Departure', icon: <EditIcon />, component: FilterDeparture },
  { id: 'ticketupdatesm', label: 'Update Tickets', icon: <EditIcon />, component: FilterClientTickets },
  
];



const CALENDAR_INNER = [
  { id: 'southyarracalendar', label: 'South Yarra', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/apprjJS4aecux6Cf1/shrDwVH7npaogCbbL?backgroundColor=dark" /> },
  { id: 'ticketcalendar', label: 'Ticket', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appUbsPnUAWdyKLEC/shr9GBQSoc9Ywm7Na?backgroundColor=dark" /> },
];



const PERSONAL_INNER = [
  { id: 'passwordm', label: 'Password', icon: <LockIcon />, component: ChangePassword },
];



const FilterDeparturePage = () => {
  const [activeTab, setActiveTab] = useState("workflowiglu");
  const { homeAccent } = useUser();

  

  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'workflowiglu' && <InnerTabsd tabs={WORKFLOW_INNER} defaultId="newform"/>}
        {activeTab === 'updateiglu' && <InnerTabsd tabs={UPDATE_INNER} defaultId="updatedepartesm"/>}
        {activeTab === 'calendariglu' && <InnerTabsd tabs={CALENDAR_INNER} defaultId="southyarracalendar"/>}
        {activeTab === 'personaliglu' && <InnerTabsd tabs={PERSONAL_INNER} defaultId="passwordm"/>}
        
        
      </div>
    </div>
  );
};



export default FilterDeparturePage;